import { constants } from '../constants'

export const getInteractionWidth = state => {
    let interactionWidth = 0;
    if (state.width > constants.layout.breakpoint.break1) {
        interactionWidth = state.width * 0.93
       return interactionWidth / 2
        // interactionWidth = state.width - interactionWidth
    } else {
      return state.width
    };
}

export const getMaxHeightVideoDocuments = ( state, userData, inputHeight ) => {
    let maxHeight = 0;
    if (userData && userData.provider) {
        maxHeight = state.height - (235 + inputHeight)
       return maxHeight
    } else if (userData && !userData.provider){
        maxHeight = state.height - 235
      return maxHeight
    };
}

export const getMaxHeightPhotoLog = ( state, userData, inputHeight ) => {
    let maxHeight = 0;
    if (userData && !userData.provider) {
        maxHeight = state.height - (235 + inputHeight)
       return maxHeight
    } else if (userData && userData.provider){
        maxHeight = state.height - 235
      return maxHeight
    };
}

export const getMaxHeightChat = ( state, userData, inputHeight ) => {
    let maxHeight = 0;
    if (userData) {
        maxHeight = state.height - (235 + inputHeight)
       return maxHeight
    } 
}


// WEBPACK FOOTER //
// ./src/js/utils/layoutUtils.js